import React from 'react'
import { StoreWrap, config as _c, Block, app, api, config } from 'xadmin'
import { C } from 'xadmin-ui'
import { IsAuthenticated, HasPermission } from 'xadmin-auth'
import { Icon } from 'xadmin-ui'
import { IconContext } from '../../components/Icon'
import _ from 'lodash'
import { Layout, Menu, Button, Drawer, Steps, Row } from 'antd'
import MainMenu from './MainMenu'
import Error from './Error'
import { AppProvider } from '../../dashboard/AppPage'
import PressMoneyModal from './../../apps/setting/PressMoney'
import '../../message'

const { Header, Content, Footer, Sider } = Layout
const name = 'mainmenu'

import './layout.css'

@IsAuthenticated
@StoreWrap('system.settings')
class App extends React.Component {

  state = {
    collapsed: false,
    mode: 'inline',
    isHome: true,
    error: null,
    isFullScreen: 'init'
  }

  constructor(props) {
    super(props)
    if (props.settings?.mobilePage?.mobileHome) {
      // 设置移动页面头
      const content = 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no'
      const metas = document.getElementsByTagName('meta')
      let viewport
      for (let i = 0; i < metas.length; i++) {
        const meta = metas[i];
        if (meta.name == 'viewport') {
          viewport = meta
        }
      }
      if (viewport) {
        // viewport.content = content
      } else {
        viewport = document.createElement('meta')
        viewport.name = 'viewport'
        viewport.content = content
        document.getElementsByTagName('head')[0].appendChild(viewport)
      }

    }
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      mode: !this.state.collapsed ? 'vertical' : 'inline'
    })
  }
  setIsHome = v => {
    this.setState({ isHome: v })
  }

  logoOnClick = () => {
    this.setState({ isHome: true })
    app.go('/app/')
  }

  componentDidCatch(error, info) {
    this.setState({ error })
  }
  componentDidMount() {
    const { settings } = this.props
    settings.customPage?.dashboard?.id && api({ name: 'core/dashboard/' }).fetch(settings.customPage?.dashboard?.id, {})
      .then(({ json }) => {
        this.setState({ isFullScreen: json?.isFullScreen })
      })
  }

  verticalLayout = (children) => {
    const { collapsed } = this.state
    const { settings } = this.props
    let style = { overflow: 'auto', overflowX: 'hidden', height: '100vh', position: 'fixed', left: 0 }
    let bgground = (!settings?.layout || settings?.layout == 'layout1') && (!settings?.theme || settings?.theme == 'default') ? { background: '#4359C7' } : {}
    return (
      <Layout style={{ minHeight: '100vh', height: '100%' }}>
        <Block name="main" />
        {/* <DrawerLead /> */}
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{ ...style, ...bgground }}
          className={!_.isEmpty(bgground) ? 'defaultBg' : ''}
        >
          <div className="logo" onClick={this.logoOnClick}>
            {/* {_c('site.logo')} */}
            {/* {_c('site.title')} */}
            <img src={settings.reception_logo || settings.logo || require('./../../icon/logo.png')} alt="" />
            <h4 class="Settings-title" dangerouslySetInnerHTML={{ __html: settings.reception_name || settings.name }}></h4>
          </div>
          <MainMenu name={name} mode={settings?.layout_mode || 'vertical'} setIsHome={this.setIsHome} isHome={this.state.isHome} />
        </Sider>
        <Content style={{ minHeight: '100vh', height: '100%', marginLeft: !collapsed ? 200 : 80, transition: 'margin .2s' }}>
          <Header className="main-header" style={{
            display: 'flex', height: 50, lineHeight: '50px',
            justifyContent: 'space-between', zIndex: 10,
            backgroundColor: settings && settings.customPage && settings.customPage.headerBackgrounColor || '',
          }}>
            <Icon
              style={{
                color: '#fff',
                fontSize: 16,
                padding: '0 16px',
                lineHeight: '50px',
                cursor: 'pointer',
                transition: 'color .3s'
              }}
              className="trigger"
              type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={this.toggle}
            />
            {/* <Breadcrumb routes={routes} params={params} itemRender={itemRender} style={{ float: 'left', lineHeight: '47px' }} /> */}
            <Block name="top.right" >
              {items => (
                <Menu style={{ width: 360, minWidth: 48, textAlign: 'right' }} className="top-menu" mode="horizontal">{items}</Menu>
              )}
            </Block>
          </Header>
          <Content className=" ant-layout main-content " style={{ overflow: 'initial', minHeight: 'calc(100% - 120px)', height: 'inherit' }}>
            {children}
            <Block name="changePwd" />
            <PressMoneyModal />
          </Content>
          {
            settings['copyright'] ? <Footer style={{ textAlign: 'center' }}>
              <slot>{_c('site.copyright')}</slot>
            </Footer> : null
          }
        </Content>
      </Layout >
    )
  }

  horizontalLayout = (children) => {
    const { settings, location: { pathname } } = this.props
    // 画面清除背景色
    const bckColor = pathname.indexOf('view') > -1 && pathname.indexOf('dashboard') && 'transparent'
    // 系统名称样式 默认自动换 检测是不是html
    const systemNameStyleWidth = settings?.reception_name?.indexOf('<div>') < 0 ? { minWidth: 120 } : {}
    const systemNameStyle = settings?.reception_name ? { whiteSpace: 'nowrap' } :
      { wordWrap: 'break-word', textAlign: 'center', ...systemNameStyleWidth }
    return (
      <Layout className="layout layout2" style={{
        minHeight: '100vh', paddingTop: 64,
        backgroundColor: bckColor,
      }}>
        <Block name="main" />
        <Block name="changePwd" />
        <PressMoneyModal />
        {/* <DrawerLead /> */}
        <IconContext.Provider value={{ place: 'topMenu' }}>
          <Header className="main-header" style={{
            display: 'flex', justifyContent: 'space-between', zIndex: 10,
            backgroundColor: settings && settings.customPage && settings.customPage.headerBackgrounColor || '',
            position: 'fixed', top: 0, left: 0, right: 0
          }}>
            <div className="logo" id='front-logo' onClick={this.logoOnClick}>
              {/* {_c('site.logo')} */}
              {/* {_c('site.title')} */}
              <img src={settings.reception_logo || settings.logo || require('./../../icon/logo.png')} alt="" />
              {(settings.reception_name) ? <h4 class="Settings-title" style={systemNameStyle} dangerouslySetInnerHTML={{ __html: settings.reception_name || settings.name }}></h4> : null}
            </div>
            <MainMenu name={name} mode='horizontal' className='inline' setIsHome={this.setIsHome} isHome={this.state.isHome} />
            <Block name="top.right" >
              {items => (
                <Menu style={{ width: 380, textAlign: 'right', marginTop: 5 }}
                  className="top-menu front-top-menu" mode="horizontal">{items}</Menu>
              )}
            </Block>
          </Header>
        </IconContext.Provider>
        <Content className="main-content" style={{ minHeight: 'calc(100% - 120px)', height: 'calc(100vh - 138px)' }}>
          {children}
        </Content>
        {
          settings['copyright'] ? <Footer style={{ textAlign: 'center' }}>
            <slot>{_c('site.copyright')}</slot>
          </Footer> : null
        }

      </Layout >
    )
  }
  getDashboardState = (arg) => {
    this.setState({ isFullScreen: arg.isFullScreen })
  }

  render() {
    const { routes, params, settings, location: { query } } = this.props
    const { error } = this.state
    const home = settings && settings.customPage && (_c('isMobile') ?
      (settings?.mobilePage?.mobileHome) : settings.customPage.home)

    let children = this.props.children
    children.props.params.getDashboardState = this.getDashboardState
    if (error) {
      children = <div style={{ marginTop: '1rem' }}><Error error={error} onClose={() => this.setState({ error: null })} /></div>
    }
    const fullscreen = window.location?.pathname?.indexOf('fullscreen') > -1 || this.state?.isFullScreen == true // 增加 path 中传 fullscreen

    if (query && (query.embed || query.fullscreen || fullscreen)) {
      return (<Layout className="layout layout-full" style={{ minHeight: '100vh', height: '100vh', }}>
        <Block name="main" />
        <Block name="changePwd" />
        <PressMoneyModal />
        <Content className="main-content">{children}</Content>
      </Layout>)
    } else {
      const DashboardPageView = C('DashboardPageView')
      if (home && home.id && DashboardPageView) {
        if (this.state.isFullScreen != 'init' && (_.isBoolean(this.state.isFullScreen) && this.state.isFullScreen)) {
          return <>{children}<Block name="changePwd" /><PressMoneyModal /></>
        } else if (this.state.isFullScreen && this.state.isFullScreen != 'init') {
          return <>{children}<Block name="changePwd" /><PressMoneyModal /></>
        } else {
          return <CustomApp id={home.id} parentChildrens={children} />
        }
      } else {
        if ((_.isBoolean(this.state.isFullScreen) && this.state.isFullScreen)) return children
        return settings.layout == undefined || settings.layout == 'layout1' ?
          this.verticalLayout(children) : this.horizontalLayout(children)
      }
    }
  }
}

const CustomApp = props => {
  const { id, parentChildrens } = props
  const [dashboard, setDashboard] = React.useState(null)

  React.useEffect(() => {
    api({ name: 'core/dashboard' }).get(id).then(res => {
      setDashboard(res)
    })
  }, [id])

  return (
    <AppProvider parentChildrens={parentChildrens}>
      <div className="custom-app">
        <Block name="main" />
        <Block name="changePwd" />
        <PressMoneyModal />
        {dashboard ? <C is="DashboardPageView" item={dashboard} /> : null}
      </div>
    </AppProvider>
  )
}


export default App
